import { render, staticRenderFns } from "./NowBlock.vue?vue&type=template&id=a23e7e3e&"
import script from "./NowBlock.vue?vue&type=script&lang=js&"
export * from "./NowBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports